import { render, staticRenderFns } from "./ContentBody.vue?vue&type=template&id=54afb05c"
import script from "./ContentBody.vue?vue&type=script&lang=js"
export * from "./ContentBody.vue?vue&type=script&lang=js"
import style0 from "./ContentBody.vue?vue&type=style&index=0&id=54afb05c&prod&scped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports